import axios from "axios";
import { endpoints } from "../api/endpoint";

const AWS_REGION = "us-east-1";

export const BUCKET_NAME = "test-pre-onboarding";

export const getSignedUrl = async (s3Key, bucketName) => {
  try {
    const response = await axios.post(
      endpoints.s3SignedUrl,
      {
        bucket: bucketName,
        key: s3Key,
        contentType: "application/octet-stream",
      },
      {
        headers: { "Content-Type": "application/json" },
        timeout: 10_000,
      }
    );

    return response.data.signedUrl;
  } catch (error) {
    console.error("Signed URL error:", error);
    throw error;
  }
};

export const uploadToS3 = async (file, signedUrl, options = {}) => {
  const { onProgress, timeout = 60_000, retries = 3 } = options;
  let lastError = null;

  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      await axios.put(signedUrl, file, {
        headers: {
          "Content-Type": file.type || "application/octet-stream",
        },
        timeout,
        onUploadProgress: (event) => {
          if (event.total && onProgress) {
            onProgress(Math.round((event.loaded * 100) / event.total));
          }
        },
      });

      return;
    } catch (err) {
      console.error("Upload error:", err);
      lastError = err;
      if (attempt < retries) {
        await new Promise((r) =>
          setTimeout(r, Math.min(1000 * 2 ** attempt, 8000))
        );
      }
    }
  }

  throw new Error(
    lastError instanceof Error ? lastError.message : "S3 upload failed"
  );
};

export const getPublicS3Url = (bucket, key) => {
  return `https://${bucket}.s3.${AWS_REGION}.amazonaws.com/${encodeURIComponent(
    key
  )}`;
};

export const uploadFileToS3 = async (bucketName, file, s3Key, onProgress) => {
  onProgress?.(5);

  const fileSize = file.size;

  const signedUrl = await getSignedUrl(s3Key, bucketName);
  onProgress?.(15);

  await uploadToS3(file, signedUrl, {
    onProgress: (p) => onProgress?.(15 + (p * 80) / 100),
  });

  const s3Url = getPublicS3Url(bucketName, s3Key);

  onProgress?.(100);
  return { s3Key, s3Url, signedUrl, fileSize };
};

export const validateFile = (file, maxSizeMB = 500) => {
  if (!file) return { valid: false, error: "No file selected" };

  if (file.size / (1024 * 1024) > maxSizeMB) {
    return { valid: false, error: `Max ${maxSizeMB}MB allowed` };
  }

  // const allowed = [".bin"];
  // if (!allowed.some((e) => file.name.endsWith(e))) {
  //   return { valid: false, error: "Invalid file type" };
  // }

  return { valid: true };
};
